<template>
    <!-- Start Items list -->
    <div class="m-orderItems" v-if="items && items.length > 0">
      <ul>
        <li v-for="(item, index) in items" v-bind:key="index">
          <span>
            <div class="m-orderItem__title">{{ item.product_type.name }}</div>
            <div class="m-orderItem__price">{{ item.base_price }}</div>
          </span>
          <br>
          <div v-if="item.quantity > 1" class="m-orderItem__quantity">
            Quantity: <span class="m-orderItem__number">{{ item.quantity }}</span>
          </div>
          <span v-if ="hasPromotion">
            <div v-if ="notSubscriptionPromotion(item)" class="m-orderItem__promotion">
                <div v-if="item.promotion_discount_percentage > 0">
                <span>Discount</span> - {{ item.promotion_discount_percentage }}% off
                </div>
                <div v-if="item.promotion_discount_fixed_amount > 0">
                <span>Discount</span> - {{ item.promotion_discount_fixed_amount }} {{currency}} off
                </div>
            </div>
            <div v-if ="subscriptionPromotion(item) && !tllRemainingDays" class="m-orderItem__promotion">
                <div v-if="item.promotion_description !== null">
                <span>Discount</span> - {{ item.promotion_description }}
                </div>
                <div class="smaller-text" v-if="PromotionBillingCycleExpiry(item)">
                {{currency}} {{ item.total_amount_without_promotion
                }}{{subscriptionBillingPeriodCycle(item.product_type.billing_period)}} once
                promotion ends.
                <span v-if="item.tax_rate !== 0">
                    Includes {{item.tax_rate}}% tax
                </span>
                </div>
                <div v-else>
                Offer valid for lifetime of your subscription
                </div>
            </div>
            <div v-if="!tllRemainingDays" class="m-orderItem__discountAmount"> - {{ getDiscount(item) }}</div>
          </span>
        </li>
      </ul>
      <hr>        
    </div>
    <!-- end items list -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    items: state => state.cart.items,
    currency: state => state.cart.currency,
    tllRemainingDays: state => state.cart.items[0] ? state.cart.items[0].tll_remaining_days : 0,
    hasPromotion () {
      if (this.items !== undefined && this.items.length > 0) {
        for (const index in this.items) {
          if (this.items[index].base_price !== this.items[index].price) {
            return true
          }
        }
      }
      return false
    }
  }),
  methods: {
    subscriptionBillingPeriodCycle (billingPeriod) {
      switch (billingPeriod) {
        case 0:
          return ''
        case 1:
          return '/m'
        case 12:
          return '/y'
        default:
          return ' every ' + billingPeriod + ' months'
      }
    },
    notSubscriptionPromotion (item) {
      return item.base_price !== item.price && !item.product_type.subscription
    },
    subscriptionPromotion (item) {
      return item.base_price !== item.price && item.product_type.subscription
    },
    PromotionBillingCycleExpiry (item) {
      return item.promotion_end_date
    },
    getDiscount (item) {
      return (item.base_price - item.price).toFixed(2)
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderItems.vue?da470ea8